/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetProductAssetUploadUrlMutationVariables = Types.Exact<{
  input: Types.GetProductAssetUploadUrlInput;
}>;


export type GetProductAssetUploadUrlMutation = { getProductAssetUploadUrl: { __typename: 'GetProductAssetUploadUrlResult', uploadUrl: string } };


export const GetProductAssetUploadUrlDocument = gql`
    mutation GetProductAssetUploadUrl($input: GetProductAssetUploadUrlInput!) {
  getProductAssetUploadUrl(input: $input) {
    uploadUrl
  }
}
    `;
export type GetProductAssetUploadUrlMutationFn = Apollo.MutationFunction<GetProductAssetUploadUrlMutation, GetProductAssetUploadUrlMutationVariables>;

/**
 * __useGetProductAssetUploadUrlMutation__
 *
 * To run a mutation, you first call `useGetProductAssetUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetProductAssetUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getProductAssetUploadUrlMutation, { data, loading, error }] = useGetProductAssetUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetProductAssetUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<GetProductAssetUploadUrlMutation, GetProductAssetUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetProductAssetUploadUrlMutation, GetProductAssetUploadUrlMutationVariables>(GetProductAssetUploadUrlDocument, options);
      }
export type GetProductAssetUploadUrlMutationHookResult = ReturnType<typeof useGetProductAssetUploadUrlMutation>;
export type GetProductAssetUploadUrlMutationResult = Apollo.MutationResult<GetProductAssetUploadUrlMutation>;
export type GetProductAssetUploadUrlMutationOptions = Apollo.BaseMutationOptions<GetProductAssetUploadUrlMutation, GetProductAssetUploadUrlMutationVariables>;